import * as React from 'react';
import { useSelector } from 'react-redux';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { PromoCompilationItem } from '../../../../components/PromoCompilation';
import { selectPage } from '../../../../selectors/analytics';
import {
  selectPromoCompilationProviders,
  selectPromoCompilationTitle,
  selectPromoCompilationUrl,
} from '../../../../selectors/promoComparison';
import { TPromoCompilationType } from '../../../../types/promoSelection';
import { getPromoCompilationAnalytics, getPromoCompilationBackgroundColor } from '../../helpers';
import { PromoCompilationContentContainer } from '../PromoCompilationContent';
import { PromoCompilationIllustrationContainer } from '../PromoCompilationIllustration';

export interface IPromoCompilationItemProps {
  type: TPromoCompilationType;
}

export const PromoCompilationItemContainer: React.FC<IPromoCompilationItemProps> = ({ type }) => {
  const title = useSelector(selectPromoCompilationTitle(type));
  const url = useSelector(selectPromoCompilationUrl(type));
  const page = useSelector(selectPage);
  const providers = useSelector(selectPromoCompilationProviders);
  const backgroundColor = getPromoCompilationBackgroundColor(type);
  const { trackAfterView, trackClick } = getPromoCompilationAnalytics(type);

  const handleAfterView = React.useCallback(() => {
    trackAfterView({ providers, page });
  }, [trackAfterView, page, providers]);

  const handleClick = React.useCallback(() => {
    trackClick({ page });
  }, [trackClick, page]);

  return (
    <ActionAfterViewObserver callback={handleAfterView} wrapper={false}>
      <PromoCompilationItem
        content={<PromoCompilationContentContainer type={type} />}
        illustration={<PromoCompilationIllustrationContainer type={type} />}
        title={title}
        url={url}
        backgroundColor={backgroundColor}
        onClick={handleClick}
      />
    </ActionAfterViewObserver>
  );
};
